// Admin tarafindan toplu push gonderim icin SDK yardimcilari.
export async function promosyonPushGonder(istemci, istek) {
    return istemci.istek('/admin/bildirim/promosyon', {
        method: 'POST',
        body: JSON.stringify(istek),
    });
}
export async function promosyonPushIstatistik(istemci) {
    return istemci.istek('/admin/bildirim/promosyon/istatistik');
}
//# sourceMappingURL=bildirim.js.map